module.exports = __webpack_public_path__ + "pc/img/img13.cf6fa7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teachers/img13.png
// module id = RdZZ
// module chunks = 3